import bikeTypeSupportsFitting from "../FittingSupport";
import React from "react";
import {useTranslation} from "react-i18next";

const ResultMessage = ({message, noResults, bikeType}) => {
    const apiMessage = String(message);
    const [t,] = useTranslation('result');

    let messageHTML;

    switch (apiMessage) {
        case "1: No models in selection":
            messageHTML = (
                <div>
                    <p>{t('Helaas hebben wij geen match kunnen vinden die voldoet aan jouw specifieke wensen')}.</p>
                    <ul>
                        <li>{t('Result -Zoek breder')}</li>
                    </ul>
                </div>
            );
            break;
        case "2: Few models in selection and no fit":
            messageHTML = (
                <div>
                    <p>{t('Helaas hebben wij geen match kunnen vinden die voldoet aan jouw specifieke wensen')}.</p>
                    <ul>
                        <li>{t('Result -Zoek breder')}</li>
                    </ul>
                </div>
            );
            break;
        case "3: Many models in selection and no fit":
            messageHTML = (
                <div>
                    <p>{t('Helaas hebben wij geen model kunnen vinden met passende afmetingen')}.</p>
                    <ul>
                        <li>{t('Controleer of de opgegeven lichaamsmaten kloppen')}</li>
                        <li>{t('Result -Pas de wenselijke')}</li>
                    </ul>
                </div>
            );
            break;
        case "4: Many models in selection and few fit":
            messageHTML = (
                <div>
                    <p>{t('Result -Wij hebben maar')}:</p>
                    <ul>
                        <li>{t('Controleer of de opgegeven lichaamsmaten kloppen')}</li>
                        <li>{t('Result -Pas de wenselijke')})</li>
                    </ul>
                </div>
            );
            break;
        case "5: Few models in selection and few fit":
            messageHTML = (
                <div>
                    <p>{t('Result -Wij hebben maar weinig')}:</p>
                    <ul>
                        <li>{t('Result -Zoek breder')}</li>
                    </ul>
                </div>
            );
            break;
        default:
            if (!bikeTypeSupportsFitting(bikeType)) {
                messageHTML = '';
                break;
            } else if (noResults) {
                messageHTML = (
                    <div>
                        <p>{t('Helaas hebben wij geen model kunnen vinden met passende afmetingen')}.</p>
                        <ul>
                            <li>{t('Controleer of de opgegeven lichaamsmaten kloppen')}</li>
                            <li>{t('Result -Pas de wenselijke')})</li>
                        </ul>
                    </div>
                );
            }
    }

    return (
        <React.Fragment>
            {messageHTML &&
            <div className="message-container">
                {messageHTML}
            </div>
            }
        </React.Fragment>
    );


};

export default ResultMessage
